import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CurrentUserService, UserService } from 'src/app/user/services';
import { GridConfiguration } from '../../user/models/grid-configuration';
import { DateTimeService } from '../../shared/datetime/datetime.service';
import { User } from '../../user/models/user';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../../shared/grid/biz-grid.directive';
import { DxoEditingModule, DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, DxoLookupModule, DxiButtonModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { PermissionRequiredDirective } from '../../shared/authentication/permission-required.directive';
import { ChangeLogLinkComponent } from '../../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../../shared/change-log/change-log-link-entity/change-log-link-entity.directive';

@Component({
    selector: 'app-tracking-search-views-grid',
    templateUrl: './tracking-search-views-grid.component.html',
    styleUrls: ['./tracking-search-views-grid.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxDataGridModule, BizDataGridDirective, DxoEditingModule, DxoColumnFixingModule, DxiColumnModule, DxiValidationRuleModule, DxoLookupModule, DxiButtonModule, DxTemplateModule, PermissionRequiredDirective, ChangeLogLinkComponent, ChangeLogLinkEntityDirective]
})
export class TrackingSearchViewGridComponent {
    @Input() gridusers: User[] = [];
    @Input() configs: GridConfiguration[] = [];
    @Input() defaultconfigs: GridConfiguration[] = [];
    @Output() saveView = new EventEmitter<GridConfiguration>();
    @Output() deleteView = new EventEmitter<GridConfiguration>();

    allowShowLog = false;

    constructor(
        public userService: UserService,
        public dateTimeService: DateTimeService,
        private currentUserService: CurrentUserService) {
        this.allowShowLog = this.currentUserService.hasPermission('Developer_Action_ShowLog');
    }

    allowUpdating = (e: any): boolean => {
        const isSystem: boolean = e.row.data.IsSystemConfiguration;
        const isGlobal: boolean = e.row.data.UsersId === null;
        return (!(isSystem || isGlobal));
    };

    allowDeleting = (e: any): boolean => {
        const isSystem: boolean = e.row.data.IsSystemConfiguration;
        const isGlobal: boolean = e.row.data.UsersId === null;
        return (!(isSystem || isGlobal));
    };

    onRowUpdating = (e: any): void => {
        const config = { ...e.oldData, ...e.newData } as GridConfiguration
        this.saveView.emit(config);
    };

    onRowRemoving = (e: any): void => {
        const config = e.data as GridConfiguration;
        this.deleteView.emit(config);
    };

    checkIsDefault = (ev: any): boolean => {
        const config = ev as GridConfiguration;
        const isDefault = this.defaultconfigs?.some(obj => obj.Id === config.Id) ?? false;
        return isDefault;
    };
}
